import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import privateurl from '../../../assets/private.png';
import unPrivateurl from '../../../assets/unPrivate.png';
import bordlockedPrivate from '../../../assets/bordlockedPrivate.png';
import style from './private.module.css';
import {
    cardsAtom,
    prohibitAtom,
    regenePrivateSetAtom,
    taskDetailAtom,
    walletInfoAtom,
    lastGenerateInfoAtom,
    userPermissionAtom,
    showSubscribeAtom,
    modalObjAtom
} from '../../../store';
import { getUserInfo, setPrivate } from '../../../utils/net';
import { useTips } from '../../../common/GlobalTips';
import { trackEvent } from '../../../utils/trackEvent'
import { PermissionContext } from '../../../utils/context';

const Private = forwardRef((props, ref) => {
    const {
        card: { is_private = false, task_uuid: uuid, lisenced: licensed } = {},
        style: myStyle,
        type,
    } = props;
    const [lastGenerateInfo, setLastGenerateInfo] = useRecoilState(lastGenerateInfoAtom);
    const [isPrivateHovered, setIsPrivateHovered] = useState(false);
    const prohibit = useRecoilValue(prohibitAtom);
    const taskDetail = useRecoilValue(taskDetailAtom);
    const [regenePrivate, setRegenePrivate] = useRecoilState(regenePrivateSetAtom);
    const [isPrivate, setIsPrivate] = useState(is_private);
    const walletInfo = useRecoilValue(walletInfoAtom);
    const [isSetPrivate, setIsSetPrivate] = useState(false);
    const [tip, setTip] = useState(false);
    const [lockedPrivate, setLockedPrivate] = useState(false);
    const [cards, setCards] = useRecoilState(cardsAtom);
    const [userPermission, setUserPermission] = useRecoilState(userPermissionAtom);
    const [couter, setCouter] = useState(userPermission.privateQuantity);
    const globalTip = useTips();
    const setShowSubscribe = useSetRecoilState(showSubscribeAtom)
    const setModalObj = useSetRecoilState(modalObjAtom)
    const subRef = useRef(null)
    const { isCreatorOrAbove } = useContext(PermissionContext);
    /*
        1. card 只展示is_private === true 状态
        2. generate curcounter===0  ？置灰
                    curcounter > 0  ？延迟设置
        3. detail  curcounter===0 --isPrivate===false ? 置灰
                                  --isPrivate===true ? 可以取消
                   curcounter > 0  ？ 正常取消和设置 立即设置，并且card得同步状态
        */
    useEffect(() => {
        if (!isCreatorOrAbove()) {
            if (userPermission.privateQuantity <= 0 && !is_private) {
                setLockedPrivate(true);
            } else {
                setLockedPrivate(false);
            }
        }
        setCouter(userPermission.privateQuantity);

    }, [userPermission.privateQuantity]);

    useEffect(() => {
        if (lastGenerateInfo.privateType) {
            setLastGenerateInfo({
                ...lastGenerateInfo,
                privateStatus: isPrivate
            })
        }
    }, [isPrivate])

    const handlerToSubscribe = () => {
        trackEvent('Subscribe - Page: Open')
        setShowSubscribe(true)
        setModalObj((pre) => {
            return {
                ...pre,
                state: false
            }
        })
    }

    const handleHoverPrivateEnter = () => {
        if (!isCreatorOrAbove()) {
            if (lockedPrivate) return;
            setIsPrivateHovered(true);
        }
    };

    const handleHoverPrivateLeave = () => {
        if (!isCreatorOrAbove()) {
            setIsPrivateHovered(false);
        }
    };

    const handlerPrivate = async (e) => {
        if (subRef.current && subRef.current.contains(e.target)) {
            handlerToSubscribe()
            return
        }
        if (prohibit) return;
        if (lockedPrivate) {
            setTip(true);
            setTimeout(() => {
                setTip(false);
            }, 1000);
            return;
        }
        const curCouter = userPermission.privateQuantity;
        const res = await setPrivate(taskDetail.task_uuid);
        if (!res.data.error) {
            const newInfo = await getUserInfo({});
            setRegenePrivate({
                oldPrivate: is_private,
                currentPrivate: !isPrivate,
                privatedChange: is_private !== !isPrivate,
            });
            trackEvent('Private - Switch', { isPrivate:!isPrivate })
            if (isPrivate && curCouter >= 0) {
                setIsPrivate(false);
                changeCards(false);
            } else if (!isPrivate) {
                setIsPrivate(true);
                changeCards(true);
            }
            setUserPermission((pre) => {
                return {
                    ...pre,
                    privateQuantity: newInfo.data.meta.chances_left_to_set_private_task,
                }
            })
        } else if (res.data.error === 'INSUFFICIENT_CHANCES') {
            globalTip({
                type: 'error',
                content:
                    'You have reached the maximum number of free private assets. To set this asset as private, please purchase a license.',
            });
        } else {
            globalTip({
                type: 'error',
                presetText: 'ERROR',
            });
        }
    };

    const handlerPrivateDelay = async (e) => {
        if (subRef.current && subRef.current.contains(e.target)) {
            handlerToSubscribe()
            return
        }

        if (prohibit) return;
        if (lockedPrivate) {
            setTip(true);
            setTimeout(() => {
                setTip(false);
            }, 1000);
            return;
        }

        setRegenePrivate({
            oldPrivate: is_private,
            currentPrivate: !isPrivate,
            privatedChange: is_private !== !isPrivate,
        });
        if (!isCreatorOrAbove()) {
            if (isPrivate) {
                setCouter(couter + 1);
            } else {
                setCouter(couter - 1);
            }
        }
        trackEvent('Private - Switch', { isPrivate:!isPrivate })
        setIsPrivate(!isPrivate);
        setIsSetPrivate(!isPrivate);
    };

    const changeCards = (flag) => {
        const newCards = JSON.parse(JSON.stringify(cards));
        const index = newCards.findIndex((item) => item.task_uuid === uuid);
        if (index === -1) return;
        newCards[index].is_private = flag;
        setCards(newCards);
    };

    const handlerGroupPrivate = async () => {
        const res = await setPrivate(taskDetail.task_uuid);
        if (!res.data.error) {
            trackEvent('Private - Switch', { isPrivate:!isPrivate })
            setIsPrivate(pre => !pre)
            changeCards(!isPrivate)
        } else {
            globalTip({
                type: 'error',
                presetText: 'ERROR',
            });
        }
    }

    useImperativeHandle(ref, () => ({
        setPrivateDelay: async (task_uuid) => {
            if (!isSetPrivate || regenePrivate.privatedChange === false) return;
            const data = await setPrivate(task_uuid);
            if (!data.data.error) {
                const newInfo = await getUserInfo({});
                setUserPermission((pre) => {
                    return {
                        ...pre,
                        privateQuantity: newInfo.data.meta.chances_left_to_set_private_task,
                    }
                })
                setIsPrivate(true);
            }
        },
    }));



    const CardPrivate = () => {
        return (
            <div
                style={{
                    ...myStyle,
                    background: 'rgba(35,93,247,0.15)',
                }}
                className={`${style.privateBox} ${isPrivate ? style.locked : ''}`}
            >
                <img src={privateurl} alt="private" />
            </div>
        )
    }

    const DetailPrivate = () => {
        return (
            <div
                style={{
                    ...myStyle,
                    background: isPrivate ? 'rgba(35,93,247,0.15)' : '#f8f8f8',
                    cursor: prohibit ? 'not-allowed' : '',
                }}
                className={`${style.privateBox} ${isPrivate ? style.locked : ''}`}
                onPointerDown={handlerPrivate}
                onMouseEnter={handleHoverPrivateEnter}
                onMouseLeave={handleHoverPrivateLeave}
            >
                {lockedPrivate ? (
                    <img src={bordlockedPrivate} alt="locked" />
                ) : (
                    <img src={isPrivate ? privateurl : unPrivateurl} alt="" />
                )}
                <div
                    className={style.speechBubble}
                    style={{ display: isPrivateHovered ? 'block' : 'none' }}
                    onMouseLeave={handleHoverPrivateLeave}
                >
                    <div className={style.privatehoverBox}>
                        {!licensed ? (
                            <>
                                <div className={style.hoverLine}>
                                    <div className={style.privateTips}>
                                        Keep your assets private for free
                                    </div>
                                    <div className={style.spaceholder} />
                                    <div className={style.privateCount}>
                                        <span>
                                            {userPermission.privateQuantity}
                                            &nbsp;
                                        </span>
                                        times
                                    </div>
                                </div>
                                <div className={style.subscribing}>Get unlimited private by&nbsp;
                                    <span className={style.subbscribeNow} ref={subRef}>subscribing now</span>.
                                </div>
                            </>
                        ) : (
                            <div className={style.privateTips}>
                                You have license of this asset. Set private for free.
                            </div>
                        )}

                        <div className={style.hoverBoxBottom}></div>
                    </div>
                </div>
                <div
                    className={`${tip ? style.show : style.hide} ${style.bordtip}`}
                >
                    <span>You have reached your limit.</span>
                </div>
            </div>
        )
    }

    const GeneratePrivate = () => {
        return (
            <div
                style={{
                    ...myStyle,
                    background: isPrivate ? 'rgba(35,93,247,0.15)' : '#ffffff80',
                    cursor: prohibit ? 'not-allowed' : '',
                }}
                className={`${style.privateBox} ${isPrivate ? style.locked : ''}`}
                onPointerDown={handlerPrivateDelay}
                onMouseEnter={handleHoverPrivateEnter}
                onMouseLeave={handleHoverPrivateLeave}
            >
                {lockedPrivate ? (
                    <img src={bordlockedPrivate} alt="locked" />
                ) : (
                    <img src={isPrivate ? privateurl : unPrivateurl} alt="" />
                )}
                <div
                    className={style.speechBubble}
                    style={{ display: isPrivateHovered ? 'block' : 'none' }}
                    onMouseLeave={handleHoverPrivateLeave}
                >
                    <div className={style.privatehoverBox}>
                        {!licensed ? (
                            <>
                                <div className={style.hoverLine}>
                                    <div className={style.privateTips}>
                                        Keep your assets private for free
                                    </div>
                                    <div className={style.spaceholder} />
                                    <div className={style.privateCount}>
                                        <span>
                                            {userPermission.privateQuantity}
                                            &nbsp;
                                        </span>
                                        times
                                    </div>
                                </div>
                                <div className={style.subscribing}>Get unlimited private by <span className={style.subbscribeNow} ref={subRef}>subscribing now</span>.
                                </div>
                            </>
                        ) : (
                            <div className={style.privateTips}>
                                You have license of this asset. Set private for free.
                            </div>
                        )}
                        <div className={style.hoverBoxBottom}></div>
                    </div>
                </div>
                <div
                    className={`${tip ? style.show : style.hide} ${style.bordtip}`}
                >
                    <span>You have reached your limit.</span>
                </div>
            </div>
        )
    }

    const UneditGroupPrivate = () => {
        return (
            <div
                style={{
                    ...myStyle,
                    background: 'rgba(35,93,247,0.15)',
                    cursor: prohibit ? 'not-allowed' : '',
                }}
                className={`${style.privateBox} ${style.locked}`}
            >
                <img src={privateurl} alt="" />
            </div>
        )
    }

    const EditGroupPrivate = () => {
        return (
            <div
                style={{
                    ...myStyle,
                    background: isPrivate ? 'rgba(35,93,247,0.15)' : '#ffffff80',
                }}
                className={`${style.privateBox} ${isPrivate ? style.locked : ''}`}
                onPointerDown={handlerGroupPrivate}
            >
                <img src={isPrivate ? privateurl : unPrivateurl} alt="" />
            </div>
        )
    }
    const privateComponent = {
        "card": <CardPrivate />,
        "detail": <DetailPrivate />,
        "generate": <GeneratePrivate />,
        "uneditGroup": <UneditGroupPrivate />,
        "editGroup": <EditGroupPrivate />
    }
    if ((walletInfo.confirm && walletInfo.type === 'Group') || type === "group") {
        return privateComponent['uneditGroup']
    } else if (taskDetail.group) {
        return privateComponent['editGroup']
    } else {
        return privateComponent[type]
    }
});

Private.displayName = "Private"
export default Private;
